export default __webpack_public_path__ + "static/media/image_placeholder.ae264cfc.jpg";